export interface EmptyFileApiResponse {
    success: boolean;
    code: number;
}
export interface FileApiResponse<T> {
    success: boolean;
    code: number;
    data: T | null;
}

// Requests

export interface UserSessionRequest {
    token: string | undefined;
}

export interface CreateFileRequest {
    fileName: string;
    fileSize: number;
    checksum: string;
}

export interface CreateFileFragmentRequest {
    fileFragmentIndex: number;
    size: number;
    checksum: string;
    publicKey: string;
    nonce: string;
    associatedData: string;
    ciphertext: string;
}

// ViewModels

export interface UserSessionVM {
    userSessionId: UserSessionId | undefined;
    isAuthenticated: boolean;
}

export interface ArendeVM {
    diarienummer: string,
    title: string,
    arendeType: ArendeType,
    status: ArendeStatus,
    recurring: Repeatable
}

export interface FileSessionVM {
    id: FileSessionId,
    arende: ArendeVM,
    transferType: FileSessionType,
    latestDownloadDate: Date | null,
    publicEncryptionKey: string | null,
    allowedFileTypes: string[],
    files: FileId[]
}

export interface FileVM {
    id: FileId;
    name: string;
    size: number;
    checksum: string;
    fileFragmentSize: number;
    fileFragmentCount: number;
    state: FileStatus[]
    created: Date;
    processed: Date | null;
    transferedFragments: number;
}

export interface FileFragmentVM {
    id: FileFragmentId;
    size: number;
    checksum: string;
    number: number;
    fileId: FileId;
    offset: number;
}

// Ids

export interface UserSessionId {
    value: string
}

export interface FileSessionId {
    value: string
}

export interface FileId {
    value: string
}

export interface FileFragmentId {
    value: string
}

export interface ArendeId {
    value: string
}

// ValueObjects
export interface EncryptedSymmetricKey {
    key: string,
    iv: string
}

export interface PublicEncryptionKey {
    value: string
}

// Enums
export enum FileSessionType {
    Inbound = 1,
    Outbound = 2
}

export enum FileSessionStatus {
    New = 0,
    Closed = 1,
    Open = 2,
    PendingOpen = 3, // Förekommer inte utanför Admintjänsten
}

export enum ArendeType {
    Forskning = 1,
    Statistik = 2,
    Kvalitetsregister = 3
}

export enum ArendeStatus {
    Closed = 0,
    Open = 1
}

export enum Repeatable {
    None = 0,
    Week = 7,
    Month = 30,
    Quarter = 90,
    Year = 365,
}

export enum FileStatus {
    None = 0,
    Deleted = 1,
    DeleteRequested = 2,
    FileSessionDeleted = 3,
    VulnerabilityFound = 4,
    Expired = 5,

    // Inbound
    UploadStarted = 100,
    Uploaded = 101,
    Sent = 102,
    InRegister = 103,

    // Outbound
    Processing = 200,
    Available = 201,
    DownloadStarted = 202,
    Downloaded = 203,
    Aborted = 204,
    Ready = 205,
    NotAvailable = 206
}

// Utility

export enum FilterOption {
    alla = 1,
    upp = 2,
    ned = 3,
}